import React from 'react';
import PropTypes from 'prop-types';
import I18n from 'apps/new-web/views/components/i18n';

const FusionSignIn = ({ registerUrl, loginUrl }) => {
  return (
    <div className="cta-container">
      <div className="cta-area">
        <h4><I18n>Get Started Now</I18n></h4>
        <p className="create-account"><I18n>Create your account, then download the app!</I18n></p>
        <a href={ registerUrl }><I18n>Create an account</I18n></a>
        <p className="or" aria-hidden="true"><I18n>or</I18n></p>
        <a href={ loginUrl }><I18n>Sign in to my account</I18n></a>
      </div>
    </div>
  );
};

FusionSignIn.propTypes = {
  registerUrl: PropTypes.string.isRequired,
  loginUrl: PropTypes.string.isRequired
};

export default FusionSignIn;